import type { ExpenseEntry } from '@/lib/mock/expenses';

export const PROJECT_EXPENSE_CARTEX_PRINT_KEY = 'accounting_project_expense_cartex_print_v1';

export type ProjectExpensePrintColKey =
  | 'row'
  | 'date'
  | 'beneficiary'
  | 'type'
  | 'payment'
  | 'amount'
  | 'sourceBank'
  | 'destinationBank'
  | 'attachment'
  | 'description';

export interface ProjectExpensePrintableRow extends ExpenseEntry {
  expenseTypeTitle?: string;
  sourceBankLabel?: string;
  destinationBankLabel?: string;
}

export interface ProjectExpenseCartexPrintPayload {
  title: string;
  generatedAt: string;
  project: {
    id: number;
    label: string;
    status: string;
    contractAmount: number;
  };
  filters: {
    beneficiaryLabel?: string;
    typeLabel?: string;
    dateFrom?: string;
    dateTo?: string;
  };
  rows: ProjectExpensePrintableRow[];
  printOptions: {
    tableColumns: Record<ProjectExpensePrintColKey, boolean>;
  };
  summary: {
    count: number;
    totalAmount: number;
  };
}

export const DEFAULT_PROJECT_EXPENSE_PRINT_COLUMNS: Record<ProjectExpensePrintColKey, boolean> = {
  row: true,
  date: true,
  beneficiary: true,
  type: true,
  payment: true,
  amount: true,
  sourceBank: false,
  destinationBank: false,
  attachment: true,
  description: true,
};

let memory: ProjectExpenseCartexPrintPayload | null = null;

export function saveProjectExpenseCartexPrintPayload(payload: ProjectExpenseCartexPrintPayload): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(PROJECT_EXPENSE_CARTEX_PRINT_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

export function takeProjectExpenseCartexPrintPayloadForPage(): ProjectExpenseCartexPrintPayload | null {
  if (memory) return memory;
  try {
    if (typeof localStorage === 'undefined') return null;
    const raw = localStorage.getItem(PROJECT_EXPENSE_CARTEX_PRINT_KEY);
    if (!raw) return null;
    const payload = JSON.parse(raw) as ProjectExpenseCartexPrintPayload;
    localStorage.removeItem(PROJECT_EXPENSE_CARTEX_PRINT_KEY);
    memory = payload;
    return payload;
  } catch {
    return null;
  }
}

export function releaseProjectExpenseCartexPrintMemory(): void {
  memory = null;
}
